<template>
  <div class="modal fade modal-mini modal-info modal-mini show" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" @click.self="closeModal" v-if="show_modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="list-item-content">
            <img :src="item.thumbnail" class="thumbnail" v-if="item.thumbnail">
            <div class="content-container">
              <p class="d-flex justify-content-between align-items-center">{{ item.content }} <small>{{ item.year }}</small> </p>
              <p class="item-details">{{ item.details }}</p></div>
            </div>
          <p>Add this item to:</p>
          <ul class="list-group options-list">
            <li class="list-group-item" v-for="option in options" :key="option.id" @click="addItem(option)">{{ option.name }} <small>{{ option.items.length }} items</small></li>
          </ul>
        </div>
        <div class="modal-footer">
          <div></div>
          <button type="button" class="btn btn-link btn-neutral" data-dismiss="modal" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'CopyItemModal',
  computed: {
    show_modal () {
      return this.$store.state.lists.copyItemModal.show
    },
    item () {
      return this.$store.state.lists.copyItemModal.item
    },
    options () {
      return this.$store.state.lists.copyItemModal.options
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('lists/hideCopyItemModal')
    },
    addItem (option) {
      let new_item = _.clone(this.item)
      delete new_item.id
      let new_items = _.clone(option.items)
      new_items.push(new_item)
      new_items = _.map(new_items, (item, idx) => {
        item.order = idx + 1
        return item
      })
      this.$store.dispatch('lists/saveList', {...option, items: new_items})
      this.closeModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  display: block;
  &.modal-mini{
    &.show .modal-dialog {
      transform: translate(0, 60px);
    }
    .modal-footer button:first-child {
      opacity: initial;
    }
    .modal-dialog {
      max-width: 465px;
      margin: 0 auto;
      .modal-body {
        .list-item-content {
          padding: 5px;
          display: flex;
          align-items: center;
          // border: 1px solid #9498ec;
          border-radius: 0.25rem;
          background-color: #202022;
          .content-container {
            width: 90%;
          }
          .item-details {
            opacity: 0.5;
            font-size: 85%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .thumbnail {
            max-height: 50px;
            padding: 0;
            margin-right: 5px;
          }
        }
        ul.list-group.options-list {
          max-height: 350px;
          overflow-y: scroll;
          .list-group-item {
            background-color: #3fa0ff;;
            padding: 0.5rem;
            cursor: pointer;
            &:hover {
              background-color: #0081ff;
            }
          }
        }
      }
    }
  }
}
</style>
